import { VALID_URL_PATTERN } from "../constants/valid-url-pattern";

export const isValidUrl = (url: string | null | undefined) => VALID_URL_PATTERN.test(url);
